"use client";

import { createAuthClient } from "@neondatabase/auth/next";
import { withVerificationErrorCode } from "./unverified-sign-in-workaround";

export const authClient = withVerificationErrorCode(createAuthClient());
